/**
 * Error thrown when a tag or tag group change breaks the tag rules (unknown tag or group, a
 * cycle, nesting too deep, ...). Its message is safe to show to the user who made the change.
 */
export class TagValidationError extends Error {}
